import { render, staticRenderFns } from "./PurchaseOrderOrderItems.vue?vue&type=template&id=868a90fe&scoped=true"
import script from "./PurchaseOrderOrderItems.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseOrderOrderItems.ts?vue&type=script&lang=ts&external"
import style0 from "./PurchaseOrderOrderItems.scss?vue&type=style&index=0&id=868a90fe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868a90fe",
  null
  
)

export default component.exports